import {IReduxNavigationState} from '../../@interfaces';

const state: IReduxNavigationState = {
	sidebar: [],
	loaded: false,
};

export default state;
